import React from "react";
import { useNavigate } from "react-router";
import Button from "../../components/common/button/Button";
import { routeNames } from "../../consts/routesNames";
import DisplayContacts from "../contacts/displayContacts/DisplayContacts";
import DisplayItems from "../items/displayItems/DisplayItems";
import DisplayProperties from "../properties/displayProperties/DisplayProperties";
import DisplayCompanies from "../companies/displayCompanies/DisplayCompanies";
import DisplayAssignedTasks from "./homepageAssignedTasks/DisplayAssignedTasks";
import Can from "../../components/auth/Can";
import { PERMISSIONS } from "../../auth/utils/permissionCodes";
import { useCrudPermissions } from "../../auth/hooks/useCrudPermissions";
import { useAuth } from "../../auth/hooks/usePermissions";
import "./Homepage.css";

function HomePage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { canView: canViewContacts } = useCrudPermissions(PERMISSIONS.CONTACTS);
  const { canView: canViewItems } = useCrudPermissions(PERMISSIONS.ITEMS);
  const { canView: canViewProperties } = useCrudPermissions(
    PERMISSIONS.PROPERTIES,
  );
  const { canView: canViewCompanies } = useCrudPermissions(
    PERMISSIONS.COMPANIES,
  );

  return (
    <>
      <div>
        <div className="main-container-homepage">
          <div className="btns-main-container-homepage">
            <Can permission={PERMISSIONS.CONTACTS.CREATE}>
              <div className="add-btn-container-homepage">
                <Button
                  className={"add-btn-homepage"}
                  buttonText={"Add New Contact"}
                  onClick={() => navigate(routeNames.ADD_CONTACT)}
                />
              </div>
            </Can>
            <Can permission={PERMISSIONS.ITEMS.CREATE}>
              <div className="add-btn-container-homepage">
                <Button
                  className={"add-btn-homepage"}
                  buttonText={"Add New Item"}
                  onClick={() => navigate(routeNames.ADD_ITEM)}
                />
              </div>
            </Can>
            <Can permission={PERMISSIONS.PROPERTIES.CREATE}>
              <div className="add-btn-container-homepage">
                <Button
                  className={"add-btn-homepage"}
                  buttonText={"Add New Project"}
                  onClick={() => navigate(routeNames.ADD_PROPERTY)}
                />
              </div>
            </Can>
            <Can permission={PERMISSIONS.COMPANIES.CREATE}>
              <div className="add-btn-container-homepage">
                <Button
                  className={"add-btn-homepage"}
                  buttonText={"Add New Company"}
                  onClick={() => navigate(routeNames.ADD_COMPANY)}
                />
              </div>
            </Can>
          </div>

          {isAuthenticated && (
            <DisplayAssignedTasks homePageDisplay variant="active" />
          )}

          <div className="table-main-container-homepage">
            {canViewProperties && (
              <>
                <strong className="strong-margin green">Active Projects : </strong>
                <DisplayProperties
                  homePageDisplay={true}
                  projectStatus={"active"}
                />
              </>
            )}
            {canViewContacts && (
              <>
                <strong className="strong-margin">Contacts : </strong>
                <DisplayContacts homePageDisplay={true} />
              </>
            )}
            {canViewCompanies && (
              <>
                <strong className="strong-margin">Companies : </strong>
                <DisplayCompanies homePageDisplay={true} />
              </>
            )}
            {canViewItems && (
              <>
                <strong className="strong-margin">Items : </strong>
                <DisplayItems homePageDisplay={true} />
              </>
            )}
            {canViewProperties && (
              <>
                <strong className="strong-margin blue">Future Projects : </strong>
                <DisplayProperties
                  homePageDisplay={true}
                  projectStatus={"future_on_hold"}
                />
                <strong className="strong-margin red">Finished Projects : </strong>
                <DisplayProperties
                  homePageDisplay={true}
                  projectStatus={"finished"}
                />
              </>
            )}
            {isAuthenticated && (
              <DisplayAssignedTasks homePageDisplay variant="finished" />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;
